<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="بغداد-في-منتصف-الخمسينيات">
<h1><span dir="rtl">بغدادُ في مُنتصفِ الخمسينيات</span></h1>
<p><span dir="rtl">رجع إلى البيت متأخِّرًا وألقى بجَسده المُتعَب على الفراش، حاولَ النوم لكنّه فشل عندما فضَّل عقلُه الاستمرار برسم التّخيُّلات وعرض الذّكريات والمَشاهد الّتي تؤذي روحَه.</span></p>
<p><span dir="rtl">أقبلَ الأستاذُ "صباح" وقالَ لهُ:</span></p>
<p><span dir="rtl">صباح الخير يا باشا، أراكَ ما زلتَ في فراشِك!</span></p>
<p><span dir="rtl">لم يردّ عزّام.</span></p>
<p><span dir="rtl">- ماذا حصلَ؟ هل مرضتَ مرّةً أخرى؟</span></p>
<p><span dir="rtl">لم يردّ عزّام.</span></p>
<p><span dir="rtl">فقالَ صباحُ بعدَ أن تحسّس جبينَ ابنه:</span></p>
<p><span dir="rtl">- سأبقى بجانبكَ.</span></p>
<p><span dir="rtl">- لا داعي لأنْ تَبْقى يا أبي!</span></p>
<p><span dir="rtl">ابتسمَ وقالَ: فهمتُ!</span></p>
<p><span dir="rtl">- لِمَ هذه الابتسامةُ؟ أنا لم أعد طفلًا!</span></p>
<p><span dir="rtl">ظلّ الأستاذ "صباح" مُبتسمًا وهو خارجٌ من الغرفةِ إلى الصّالة، حملَ الهاتف بيدهِ وسحب السّلكَ وأخذَ يَلفُّه، ورجعَ إلى غرفة عزّام ووضعَ الهاتفَ بجانب السّرير وغادرَ.</span></p>
<p><span dir="rtl">انتظرَ عزّام حتّى خرجَ والدُه من المنزلِ، وعلى الفور رفعَ سمّاعة الهاتف ووضعَها على أذنهِ واتّصل بها، ولم يكُن بحاجةٍ أن يقول لها شيئًا لتفهمَ أنّهُ أُصيبَ بالحُمّى من جديد.</span></p>
<p><span dir="rtl">- أمّي! قالَها بصوتٍ مبحوحٍ مُنْهكٍ.</span></p>
<p><span dir="rtl">أغلقتِ الهاتفَ بعدَ الانتهاء من المكالمةِ، ونادَت على مساعدِيها ليُجهِّزوا لها السّيارة، لَبِست مِعطفها وأخذتْ حقيبتَها، ثمَّ خرجت من المصنعِ متّجهةً إلى منزلِ الأستاذ "صباح الحمداني".</span></p>
<p><span dir="rtl">- أَسْرِعْ قليلًا". قالَت للسّائقِ، ثمَّ رجعَت إلى الوراء مُسندةً ظَهْرها، وعيناها إلى السَّماء، مُسترجعةً بعضَ الذّكريات.</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?1d0ca9b4